var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.label)?_c('li',[_c('h3',{staticClass:"font-semibold",domProps:{"textContent":_vm._s(_vm.label)}}),_c('div',{staticClass:"text-sm text-gray-700"},[_vm._v(_vm._s(_vm._f("date")(_vm.event.date,'LLLL')))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }